import { useTranslations } from "@jti/ui/providers/useTranslations";

export const MonthlyPurchaseButtonContent = () => {
  const { __ } = useTranslations();

  return (
    <ol>
      <li>{__("sticksForm.purchase_options.subscription.monthly.bullet.1")}</li>
      <li>{__("sticksForm.purchase_options.subscription.monthly.bullet.2")}</li>
      <li>{__("sticksForm.purchase_options.subscription.monthly.bullet.3")}</li>
    </ol>
  );
};
